import { combineReducers } from 'redux';
import * as contactbook from './modules/contactbook';
const reducer = combineReducers({
  contactbook: contactbook.reducer
});
export { contactbook, reducer };